import IconRoot from './Icon';
export * from './Icon.types';
export * from './Icon.props';
export * from './Icon.constants';
export default IconRoot;
